import { memo } from 'react';
import Box from '@mui/material/Box';
import _map from 'lodash/map';
//Local files
import GridSkeleton from 'components/Common/Feedback/GridSkeleton/GridSkeleton';
import EsignDocCard from 'components/EsignTemplates/Card/Card';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useCustomSelector from 'hooks/useCustomSelector';
import { esignTemplatesSelectors } from 'features/esignTemplates';

const EsignTemplatesGrid = ({ fetching }) => {
  const { data } = useCustomSelector(esignTemplatesSelectors.getEsignTemplatesData);

  if (fetching && !data?.length) return <GridSkeleton />;

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '24px 22px', justifyContent: 'center' }}>
      {_map(data, (t) => <EsignDocCard key={t?.template?.id} id={t?.id} template={t?.template} />)}
    </Box>
  )
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <EsignTemplatesGrid {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);